const Constants = {
  endpointBasePath: "/case-law-documents",
  caseLawDocumentTypePath: "/case-law-document-types",
  organisationCaseLawDocumentTypePath: "/case-law-document-types/organisation",
  organisationsPath: "/organisations",
  courtCasesPath: "/court-case",
  organisationsCaseLawDocumentTypePath: "/organisations/case-law-document-type",
  courtCaseLawDocumentPath: "/case-law-documents/court-cases",
  caseDecisionPath: "/case-decision",
  legalViewPath: "legal-views",
  attachmentPath: "/attachments",
  attachmentTypePath: "/attachment-types"
};

const CaseLawDocumentStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  RECORDED: "RECORDED",
  VERIFIED: "VERIFIED",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED",
  INVALIDATED: "INVALIDATED"
};
const ContentTypes = {
  ATTACHMENT_CONTENT_TYPE: "ATTACHMENT_CONTENT_TYPE",
  FILE_CONTENT_TYPE: "DATOTEKA",
  URL_CONTENT_TYPE: "URL"
};

const CourtCaseType = {
  PRIMARY: "PRIMARY",
  CONNECTED: "CONNECTED"
};
export default Constants;

export { CaseLawDocumentStatus };
export { ContentTypes };
export { CourtCaseType };
